import { LoginOutlined } from "@ant-design/icons";
import { Avatar, Button, Skeleton, Typography } from "antd";
import axios from "axios";
import Backdrop from "components/Nav/Backdrop/Backdrop";
import { useViewport } from "@bindeleddet/core/hooks";
import { useLoginContext } from "@bindeleddet/core/contexts/login";
import { ActiveMember } from "@bindeleddet/core/types";
import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import styled from "styled-components";
import { MenuContent } from "./NavMenu";

interface UlProps {
  open: boolean;
  pathname: string;
}

const Ul = styled.ul<UlProps>`
  list-style: none;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  white-space: nowrap;
  z-index: 140;
  li {
    line-height: 65px;
    padding: 0 10px;
    color: #f1f1f1;
  }
  li a {
    color: #f1f1f1;
  }
  a:hover {
    font-weight: bold;
  }
  @media (min-width: 901px) {
  }
`;
const { Text } = Typography;

interface Props {
  open: boolean;
  pathname: string;
}

const StyledBurger = styled.div<Props>`
  width: 2rem;
  height: 2rem;
  position: ${({ open }) => (open ? "fixed" : "absolute")};
  top: 15px;
  right: 20px;
  z-index: 150;
  display: none;
  @media (max-width: 900px) {
    display: flex;
    justify-content: space-around;
    flex-flow: column nowrap;
  }
  div {
    width: 2rem;
    height: 0.25rem;
    background-color: #ccc;
    border-radius: 10px;
    transform-origin: 1px;
    transition: all 0.3s linear;
    &:nth-child(1) {
      transform: ${({ open }) => (open ? "rotate(45deg)" : "rotate(0)")};
    }
    &:nth-child(2) {
      transform: ${({ open }) => (open ? "translateX(100%)" : "translateX(0)")};
      opacity: ${({ open }) => (open ? 0 : 1)};
    }
    &:nth-child(3) {
      transform: ${({ open }) => (open ? "rotate(-45deg)" : "rotate(0)")};
    }
  }
`;

const SlideMenu = styled.div<{ open: boolean; width: number }>`
  position: fixed;
  top: 0;
  right: 0;
  width: ${props => (props.width > 330 ? "300px" : "90vw")};
  height: 100%;
  background-color: var(--primary-color);
  z-index: 100;
  padding: 0 10px;
  transform: ${props => (props.open ? "translateX(0)" : "translateX(100%)")};
  transition: transform 0.3s ease-in-out;
  overflow-y: auto;
  overflow-x: hidden;

  /* Hide scrollbar for Chrome, Safari og Opera */
  &::-webkit-scrollbar {
    display: none;
  }

  /* Hide scrollbar for Firefox */
  scrollbar-width: none;

  /* Hide scrollbar for IE og Edge */
  -ms-overflow-style: none;
`;

const RightNav = () => {
  const { pathname } = useLocation();
  const { currentUser } = useLoginContext();
  const [activeMember, setActiveMember] = useState<ActiveMember>();
  const { width } = useViewport();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (activeMember) return;
    axios.get<ActiveMember>(`/internal/active-members/${currentUser?.id}/`).then(response => {
      setActiveMember(response.data);
    });
  });

  const StudentPageButton = () => {
    return (
      <NavLink to="/" activeStyle={{ fontWeight: "bold" }}>
        <Button style={{ color: "var(--dark)", backgroundColor: "var(--light)", margin: "auto" }}>
          <LoginOutlined /> Studentsiden
        </Button>
      </NavLink>
    );
  };
  return (
    <>
      <Ul open={false} pathname={pathname}>
        <div style={{ paddingRight: width >= 768 ? "0px" : "35px" }}>
          {activeMember ? (
            <Text style={{ lineHeight: "65px" }}>{activeMember?.full_name}</Text>
          ) : (
            <Skeleton.Input size="small" active style={{ marginTop: "20px" }} />
          )}
          {activeMember ? (
            <Avatar
              size="large"
              src={activeMember?.profile_picture}
              alt={activeMember?.first_name[0].toUpperCase()}
              style={{
                margin: "12.5px 10px",
                backgroundColor: "var(--light)",
                color: "var(--dark)",
                fontSize: "large",
              }}
            >
              {activeMember?.profile_picture === null ? activeMember?.first_name[0].toUpperCase() : null}
            </Avatar>
          ) : (
            <Skeleton.Avatar active size="large" style={{ margin: "12.5px 10px" }} />
          )}
        </div>
        {width >= 768 ? (
          <StudentPageButton />
        ) : (
          <>
            <StyledBurger open={open} onClick={() => setOpen(!open)} pathname={pathname}>
              <div />
              <div />
              <div />
            </StyledBurger>
            <Backdrop open={open} handleClick={() => setOpen(false)} />
            <SlideMenu open={open} width={width}>
              <MenuContent onSelect={() => setOpen(false)}>
                <StudentPageButton />
              </MenuContent>
            </SlideMenu>
          </>
        )}
      </Ul>
    </>
  );
};

export default RightNav;
